export function isInIframe() {
    try {
        if (window.self !== window.top) {
            return true;
        }
    } catch (e) {
        // кросс-доменный iframe
        return true;
    }

    return window.parent !== window;
}
